import React from "react";
import { Button } from "@vitalsource/vstui";
import { CaretLeftLarge } from "@vitalsource/vstui-icons";

export default class PanelHeader extends React.Component {
  render() {
    const headerClassName =
      typeof this.props.title === "object" ? "has-content" : "";
    return (
      <div className="header noselect">
        <Button
          naked
          id="figures-header-back-button"
          label={i18n.t("reader.figures.back-to-chapter-list")}
          onClick={this.props.headerClick}
          size="large"
          iconStart={<CaretLeftLarge />}
        />
        <h2
          id="special-panel-header"
          className={`panel-title no-highlight ${headerClassName}`}
          tabIndex={-1}
        >
          {this.props.title}
        </h2>
        <Button
          className="panel-close-button"
          onClick={this.props.close}
          naked
        >
          <span>
            {i18n.t("reader.panels.close-panel", {
              panelName: i18n.t("reader.panels.figures")
            })}
          </span>
        </Button>
      </div>
    );
  }
}
